import log from 'embed_v2/helpers/log'
import { useState, useEffect } from 'preact/hooks'
import { formatSeconds } from 'core/helpers/formatters'

const code = `
  var intervalId
  self.onmessage = function(e) {
    if (intervalId) {
      clearInterval(intervalId)
    }
    let secs = e.data

    intervalId = setInterval(() => {
      secs -= 1

      if (secs === 0) {
        clearInterval(intervalId)
      }

      self.postMessage(secs)
    }, 1000)
  }
`

const defaultRemain = { days: '00', hours: '00', minutes: '00', seconds: '00', totalSeconds: 0 }

export const createWorker = (callbackFn: (value: typeof defaultRemain) => void) => {
  const blob = new Blob([code], { type: 'text/javascript' })
  const worker = new Worker(window.URL.createObjectURL(blob))
  worker.addEventListener('message', e => {
    log.debug('[useRemainTimeWorker] onMessage', e.data)
    callbackFn(formatSeconds(e.data))
  })

  return worker
}

const useRemainTimeWorker = (seconds: number | undefined, callbackFn: (value: typeof defaultRemain) => void) => {
  const [worker, setWorker] = useState<Worker>()
  const [visibilityStatus, setVisibilityStatus] = useState(document.hidden)

  useEffect(() => {
    const webWorker = createWorker(callbackFn)
    setWorker(webWorker)

    return () => {
      webWorker.terminate()
    }
  }, [])

  useEffect(() => {
    const handleVisibilityChange = () => {
      setVisibilityStatus(document.hidden)
    }

    document.addEventListener('visibilitychange', handleVisibilityChange)

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange)
    }
  }, [])

  useEffect(() => {
    if (!seconds) {
      callbackFn(defaultRemain)
      return
    }

    if (!worker) return

    worker.postMessage(seconds)
  }, [seconds, worker, visibilityStatus])

  return worker
}

export default useRemainTimeWorker
